import React from 'react'
function TableColumnValues(props) {
  const { tableData } = props
  return (
    <div>
      <table className='tableclassName sticky-thc' style={{ width: '100%' }}>
        <tr
          style={{
            backgroundColor: 'lightgray',
            zIndex: '1',
            position: 'relative',
            border: '1px solid black',
          }}
        >
          <th className='tdclassName'>S.No</th>
          <th className='tdclassName'>checkbox</th>
          <th className='tdclassName'>Actions</th>
          <th className='tdclassName'>personID</th>
          <th className='tdclassName'>Image</th>
          <th className='tdclassName'>Type</th>
          <th className='tdclassName'>name En</th>
          <th className='tdclassName'>name Te</th>
          <th className='tdclassName'>about En</th>
          <th className='tdclassName'>about Te</th>
          <th className='tdclassName'>dateOfBirth</th>
          <th className='tdclassName'>Tags</th>
          <th className='tdclassName'>AdminGood</th>
          <th className='tdclassName'>AdminBad</th>
          <th className='tdclassName'>placeOfBirth En</th>
          <th className='tdclassName'>placeOfBirth Te</th>
          <th className='tdclassName'>status</th>
          <th className='tdclassName'>nickName En</th>
          <th className='tdclassName'>nickName Te</th>
          <th className='tdclassName'>otherNames En</th>
          <th className='tdclassName'>otherNames Te</th>
          <th className='tdclassName'>birthName En</th>
          <th className='tdclassName'>birthName Te</th>
          <th className='tdclassName'>almamater En</th>
          <th className='tdclassName'>almamater Te</th>
          <th className='tdclassName'>family En</th>
          <th className='tdclassName'>family Te</th>
          <th className='tdclassName'>awards En</th>
          <th className='tdclassName'>awards Te</th>
          <th className='tdclassName'>occupation En</th>
          <th className='tdclassName'>occupation Te</th>
          <th className='tdclassName'>currentlyActive</th>
          <th className='tdclassName'>yearsActive</th>
          <th className='tdclassName'>relatives En</th>
          <th className='tdclassName'>relatives Te</th>
          <th className='tdclassName'>spouse En</th>
          <th className='tdclassName'>spouse Te</th>
          <th className='tdclassName'>nationality</th>
          <th className='tdclassName'>children En</th>
          <th className='tdclassName'>children Te</th>
          <th className='tdclassName'>genres En</th>
          <th className='tdclassName'>genres Te</th>
          <th className='tdclassName'>memberOf En</th>
          <th className='tdclassName'>memberOf Te</th>
          <th className='tdclassName'>parents En</th>
          <th className='tdclassName'>parents Te</th>
          <th className='tdclassName'>notableWork En</th>
          <th className='tdclassName'>notableWork Te</th>
          <th className='tdclassName'>honours En</th>
          <th className='tdclassName'>honours Te</th>
          <th className='tdclassName'>instruments En</th>
          <th className='tdclassName'>instruments Te</th>
          <th className='tdclassName'>residence En</th>
          <th className='tdclassName'>residence Te</th>
          <th className='tdclassName'>education En</th>
          <th className='tdclassName'>education Te</th>
          <th className='tdclassName'>politicalParty En</th>
          <th className='tdclassName'>politicalParty Te</th>
          <th className='tdclassName'>otherPoliticalAffiliations En</th>
          <th className='tdclassName'>otherPoliticalAffiliations Te</th>
          <th className='tdclassName'>precededBy En</th>
          <th className='tdclassName'>precededBy Te</th>
          {/* <th className='tdclassName'>roles</th> */}
          <th className='tdclassName'>origin En</th>
          <th className='tdclassName'>origin Te</th>
          <th className='tdclassName'>works En</th>
          <th className='tdclassName'>works Te</th>
          <th className='tdclassName'>website</th>
        </tr>
        {tableData}
      </table>
    </div>
  )
}

export default TableColumnValues
